import { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import SessionExpiredModal from './components/SessionExpiredModal';
import CredencialCard from './components/CredencialCard';
import api from './services/api';

const AppContent = () => {
  const {
    isAuthenticated,
    loading,
    showSessionExpiredModal,
    closeSessionExpiredModal,
    logout,
  } = useAuth();

  const [viewerCredencial, setViewerCredencial] = useState(null);

  // Detectar si se accede desde un QR (hash en la URL)
  useEffect(() => {
    const handleHashChange = async () => {
      const hash = window.location.hash;
      const viewerMatch = hash.match(/^#viewer\/(\d+)/);

      if (viewerMatch && viewerMatch[1]) {
        const credencialId = parseInt(viewerMatch[1]);
        try {
          const response = await api.get(`/credenciales/${credencialId}`);
          setViewerCredencial(response.data);
        } catch (error) {
          console.error('Error:', error);
        }
      } else {
        setViewerCredencial(null);
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const handleSessionExpiredConfirm = () => {
    closeSessionExpiredModal();
    logout();
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="relative">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-8 h-8 bg-blue-500 rounded-full animate-pulse"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {isAuthenticated ? <Dashboard /> : <Login />}

      <SessionExpiredModal
        isOpen={showSessionExpiredModal}
        onConfirm={handleSessionExpiredConfirm}
      />

      {viewerCredencial && (
        <CredencialCard
          isOpen={true}
          onClose={() => {
            setViewerCredencial(null);
            window.location.hash = '';
          }}
          credencial={viewerCredencial}
        />
      )}
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
